import { useQuery } from '@tanstack/react-query';
import { RotationResource, ServiceRotationModal } from '@mark43/cad-api';
import { useApiClient } from '~/api-client';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { ServiceRotationFormType } from './types';

export function useServiceRotationDrawerQuery({
    form,
    eventId,
    defaultServiceRotationTypeId,
    isTowRotation,
    onSuccess,
}: {
    form: UseFormReturn<ServiceRotationFormType>;
    eventId?: number;
    defaultServiceRotationTypeId?: number;
    isTowRotation: boolean;
    onSuccess: (data: ServiceRotationModal) => void;
}) {
    const serviceRotationTypeOption = useWatch({
        control: form.control,
        name: 'serviceRotationTypeOption',
    });
    const apiClient = useApiClient();
    return useQuery(
        ['service-rotation', serviceRotationTypeOption] as const,
        ({ queryKey }) => {
            return apiClient.request<RotationResource.GetServiceRotationModal>({
                method: 'POST',
                data: {
                    eventId,
                    serviceRotationTypeId: queryKey[1]?.value ?? defaultServiceRotationTypeId,
                    isTowRotation,
                },
                url: 'rotation/modal/',
            });
        },
        {
            onSuccess: (resp) => {
                if (resp.data.data) onSuccess(resp.data.data);
            },
        }
    );
}
